import { useState, useEffect } from "react";
import { Card, CardHeader, Typography, Button, IconButton, Tooltip } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ModalsWrapper from "../../Components/Modals/ModalsWrapper";
import IdCardForm from "./IdCardForm";
import { useAuthContext } from "../../Context/AuthContext/AuthContext";
import TableLoader from "../../Components/Spinner/TableLoader";
import TableNoDataMessage from "../../Components/TableMessage/TableNoDataMessage";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link } from "react-router-dom";
import { getStatusLabel } from "../../Utils/Comibined";
import { useAllIdCardQuery } from "./api/idCardEndPoint";

const IdCard = () => {
  const { user } = useAuthContext();
  const [open, setOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const { idCard, isLoading, refetch } = useAllIdCardQuery(user.user_member_id);

  useEffect(() => {
    refetch?.();
  }, [reload, refetch]);

  return (
    <>
      <Card sx={{ mt: 5 }}>
        <CardHeader
          action={
            user?.user_member_account_status === "active" && (
              <Button variant="contained" onClick={() => setOpen(true)}>
                Request for id card
              </Button>
            )
          }
          title={
            <Typography
              sx={{ fontWeight: 700, lineHeight: 1.34, fontSize: 17 }}
            >
              ID Card
            </Typography>
          }
        />
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Requested At</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <TableLoader />
                  </TableCell>
                </TableRow>
              ) : idCard?.length ? (
                idCard.map((sIdCard) => {
                  return (
                    <TableRow key={sIdCard.id}>
                      <TableCell>{sIdCard.id}</TableCell>
                      <TableCell>{sIdCard.applicant_name}</TableCell>
                      <TableCell>
                        {moment(sIdCard.created_at).format("MMM Do YY")}
                      </TableCell>
                      <TableCell>
                        {getStatusLabel(sIdCard.status)}
                      </TableCell>
                      <TableCell>
                        {sIdCard.status?.toLowerCase() === "draft" ? (
                          <Tooltip title="View">
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpen(true);
                              }}
                            >
                              <VisibilityIcon sx={{ color: "black" }} fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="View">
                            <Link to={`/id-card-application/${sIdCard.id}`}>
                              <IconButton>
                                <VisibilityIcon sx={{ color: "black" }} fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableNoDataMessage />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
      <ModalsWrapper
        modalData={{ title: "Request for ID card" }}
        setShowModal={setOpen}
        showModal={open}
      >
        <IdCardForm
          handleClose={() => setOpen(false)}
          setReload={setReload}
        />
      </ModalsWrapper>
    </>
  );
};

export default IdCard;
